// extracted by mini-css-extract-plugin
export default {"container":"accordion-container_container__ZL+qV","content":"accordion-container_content__VnvpA"};